window.addEventListener('DOMContentLoaded', () => {
    const sendImmediately = document.querySelector('input[name="send_immediately"]');
    const sendAt = document.querySelector('input[name="send_at"]');

    if (sendAt) {
        const sendAtLabel = document.querySelector(`label[for="${sendAt.id}"]`);

        if (sendImmediately) {
            sendImmediately.addEventListener('change', () => {
                sendAt.classList.toggle('d-none');
                ['d-block', 'd-none'].map(className => sendAtLabel.classList.toggle(className));
            });
        }
    }
})
